/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {  ISuggestions } from './Suggestions'


export interface ISuggestionsData  {
suggestions: ISuggestions;
/**  Порядок подсказок в саджесте  **/
sortOrder: string[];
/**  Стратегия сортировки категорий  **/
orderingStrategy?: TSuggestionsData_OrderingStrategy;

}

export type TSuggestionsData_OrderingStrategy = | null| EOrderingStrategy

export enum EOrderingStrategy {
/** Порядок категорий закреплён за вертикалью **/
'Static' = 'static',
/** Порядок категорий считается по релевантности запроса **/
'Dynamic' = 'dynamic',

}